import { finalize } from 'rxjs/operators';
import { BasePage } from './../../base.page';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { MediaCaptureProvider } from 'src/app/services/media-capture';
import { WardrobeService } from './../../../services/wardrobe.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import {
  ProductCategoryModel,
  ProductSizeModel,
} from 'src/app/models/wardrobe.model';
import {
  brand,
  category,
  color,
  condition,
  size,
  type,
} from 'src/app/constants/general.constant';
import { EditImageModalComponent } from 'src/app/components/edit-image-modal/edit-image-modal.component';
import { CreateBrandModalComponent } from './../../../components/create-brand-modal/create-brand-modal.component';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { ChooseLocationModalComponent } from './../../../components/choose-location-modal/choose-location-modal.component';
import { ProductCategoryModalComponent } from './../../../components/product-category-modal/product-category-modal.component';
import {
  ProductBrandModel,
  ProductColorModel,
  ProductTypeModel,
  ProductConditionModel,
} from './../../../models/wardrobe.model';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { GeneralService } from 'src/app/services/general.service';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';

@Component({
  selector: 'shc-create-product',
  templateUrl: './create-product.page.html',
  styleUrls: ['./create-product.page.scss'],
})
export class CreateProductPage extends BasePage implements OnInit {
  price: number;
  form: UntypedFormGroup;
  productImages: Array<string>;
  selectedSize: ProductSizeModel;
  selectedType: ProductTypeModel;
  selectedBrand: ProductBrandModel;
  selectedColor: ProductColorModel;
  selectedCategory: ProductCategoryModel;
  productConditions: Array<ProductConditionModel>;
  productTypes: Array<ProductTypeModel>;
  selectedCondition: ProductConditionModel;
  selectedLocation: {
    location: string;
    latitude: number;
    longitude: number;
  };

  constructor(
    protected platform: Platform,
    camera: Camera,
    actionSheetCtrl: ActionSheetController,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    mediaCapture: MediaCaptureProvider,
    toastController: ToastController,
    private router: Router,
    private modalCtrl: ModalController,
    private wardrobeService: WardrobeService,
    protected generalService: GeneralService,
    private androidPermission: AndroidPermissions,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
      mediaCapture,
      actionSheetCtrl,
      camera,
    );
  }

  ngOnInit() {
    this.price = 1;
    this.form = new UntypedFormGroup({
      title: new UntypedFormControl(null, [Validators.required]),
      description: new UntypedFormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      price: new UntypedFormControl(null, [
        // Validators.required,
        Validators.min(1),
      ]),
      size_id: new UntypedFormControl(null),
      condition_id: new UntypedFormControl(null, [Validators.required]),
      color_id: new UntypedFormControl(null, [Validators.required]),
      brand_id: new UntypedFormControl(null, [Validators.required]),
      category_id: new UntypedFormControl(null, [Validators.required]),
      type_id: new UntypedFormControl(null, [Validators.required]),
      location: new UntypedFormControl(null, [
        // Validators.required
      ]),
      latitude: new UntypedFormControl(null, [
        // Validators.required
      ]),
      longitude: new UntypedFormControl(null, [
        // Validators.required
      ]),
      images: new UntypedFormControl(null),
      is_active: new UntypedFormControl(1),
    });
  }

  ionViewWillEnter() {
    this.productImages = [];
    this.getProductConditions();
    this.getTypes();
  }

  selectCondition(item: any) {
    this.selectedCondition = item;
    this.form.get('condition_id')?.setValue(item?.id);
  }

  async managePicUpload(event: Event) {
    event.stopPropagation();
    await this.cordovaPictureChange();
    /*if (this.platform.is('android')) {

      this.androidPermission.checkPermission(this.androidPermission.PERMISSION.CAMERA).then(
        async (result) => {
          console.log(result.hasPermission)
          if(result.hasPermission){
            await this.cordovaPictureChange();
          } else {
            this.androidPermission.requestPermissions([this.androidPermission.PERMISSION.CAMERA])
          }
        },
        err => this.androidPermission.requestPermissions([this.androidPermission.PERMISSION.CAMERA])
      );

      // this.androidPermission.checkPermission(this.androidPermission.PERMISSION.CAMERA).then(
      //   async (result) => {
      //     console.log('Has camera permission?' + JSON.stringify(result.hasPermission));
      //     if (!result.hasPermission) {
      //       this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
      //         .then(async (permResp) => {
      //           console.log('req camera perm response: ', permResp);
      //           // alert('Has camera permission?' + JSON.stringify(permResp));
      //           if (permResp.hasPermission) {
      //             await this.cordovaPictureChange();
      //           } else {
      //             console.log('called here...')
      //             this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
      //           }
      //         });
      //     } else {
      //       await this.cordovaPictureChange();
      //     }
      //   },
      //   err => this.androidPermission.requestPermissions(this.androidPermission.PERMISSION.CAMERA)
      // );

    } else {
      await this.cordovaPictureChange();
    }*/
  }

  async cordovaPictureChange() {
    if (
      (window as any).cordova &&
      (window as any).cordova.platformId !== 'browser'
    ) {
      {
        const alert = await this.actionSheetCtrl.create({
          header: this.translate.instant(marker('Camera.Select')),
          backdropDismiss: true,
          cssClass: 'removeCancelButton',
          buttons: [
            {
              icon: 'close',
              text: this.translate.instant(marker('Buttons.Cancel')),
              role: 'cancel',
            },
            {
              icon: 'camera',
              text: this.translate.instant(marker('Camera.Source.Camera')),
              handler: () => {
                this.mediaCapture
                  .getPicture(
                    this.camera.PictureSourceType.CAMERA,
                    true,
                    this.camera.MediaType.PICTURE,
                  )
                  .then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          this.editImage(result.file);
                        } else {
                          this.showToast(
                            this.translate.instant(
                              marker('ValidationMessage.ValidImage'),
                            ),
                          );
                        }
                      }
                      this.hideLoader();
                    },
                    (error) => {
                      this.hideLoader();
                      if (error) {
                        if (error === 20) {
                          this.showToast(
                            this.translate.instant(
                              marker('ValidationMessage.PermissionDenied'),
                            ),
                          );
                          return;
                        }
                      } else {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.NoFileSelected'),
                          ),
                        );
                      }
                    },
                  );
              },
            },
            {
              icon: 'images-outline',
              text: this.translate.instant(
                marker('Camera.Source.PhotoLibrary'),
              ),
              handler: () => {
                this.mediaCapture
                  .getPicture(
                    this.camera.PictureSourceType.PHOTOLIBRARY,
                    true,
                    this.camera.MediaType.PICTURE,
                  )
                  .then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          this.editImage(result.file);
                        } else {
                          this.showToast(
                            this.translate.instant(
                              marker('ValidationMessage.ImageOnly'),
                            ),
                          );
                        }
                      }
                      this.hideLoader();
                    },
                    (error) => {
                      this.hideLoader();
                      if (error) {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.PermissionDenied'),
                          ),
                        );
                      } else {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.NoFileSelected'),
                          ),
                        );
                      }
                    },
                  );
              },
            },
          ],
        });
        await alert.present();
      }
    }
  }

  getProductConditions() {
    this.wardrobeService.conditionsList().subscribe(
      (res) => {
        this.productConditions = res.data.filter((con) => con.rating !== null);
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  getTypes() {
    this.wardrobeService.typesList({ page: 1, per_page: 100 }).subscribe(
      (res) => {
        this.productTypes = res.data;
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  resizeImage(base64: string, maxDimension = 1600, quality = 0.9): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = Math.round((height * maxDimension) / width);
            width = maxDimension;
          } else {
            width = Math.round((width * maxDimension) / height);
            height = maxDimension;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.onerror = () => resolve(base64);
      img.src = base64;
    });
  }

  onImageChange(event: any) {
    const target = event.target as HTMLInputElement;
    const imageFiles = target.files;
    if (imageFiles.length > 1) {
      // Meerdere foto's tegelijk geselecteerd: direct toevoegen, geen bewerk-scherm per foto
      Array.from(imageFiles).forEach((file) => {
        this.mediaCapture.readFile(file).then((base64data) => {
          if (base64data.indexOf('data:image/') >= 0) {
            this.resizeImage(base64data).then((resized) => {
              this.productImages.push(resized);
            });
          }
        });
      });
    } else {
      this.mediaCapture.readFile(imageFiles[0]).then((base64data) => {
        if (base64data.indexOf('data:image/') >= 0) {
          this.resizeImage(base64data).then((resized) => {
            this.editImage(resized);
          });
        }
      });
    }
  }

  async editImage(image) {
    const modal = await this.modalCtrl.create({
      component: EditImageModalComponent,
      componentProps: {
        image,
      },
      cssClass: 'edit-image-modal',
      canDismiss: true,
      id: 'editImage',
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        // push the images in array to display on frontend
        this.productImages.push(data.data);
        console.log(this.productImages);
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async openProductCategoryModal(value: string) {
    const modal = await this.modalCtrl.create({
      component: ProductCategoryModalComponent,
      componentProps: {
        value,
        typeId: this.selectedType ? this.selectedType?.id : null,
        categoryId: this.selectedCategory ? this.selectedCategory?.id : null,
        conditions: this.productConditions,
      },
      cssClass: 'product-category-modal-create',
      id: 'productCategory',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
      // initialBreakpoint: 0.9,
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        if (value === brand) {
          if (data.data.name.toLowerCase() === 'others') {
            this.createBrand();
          } else {
            this.selectedBrand = data.data;
          }
          this.form.controls.brand_id.setErrors(null);
        } else if (value === category) {
          this.selectedCategory = data.data;
          this.form.controls.category_id.setErrors(null);
          this.selectedSize = null;
        } else if (value === color) {
          this.selectedColor = data.data;
          this.form.controls.color_id.setErrors(null);
        } else if (value === size) {
          this.selectedSize = data.data;
          this.form.controls.size_id.setErrors(null);
        } else if (value === condition) {
          this.selectedCondition = data.data;
          this.form.controls.condition_id.setValue(data.data.id);
        }
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  selectType(item: any) {
    this.selectedType = item;
    this.selectedSize = null;
    this.form.get('type_id')?.setValue(item?.id);
  }

  async createBrand() {
    const modal = await this.modalCtrl.create({
      component: CreateBrandModalComponent,
      cssClass: 'create-brand',
      canDismiss: true,
      id: 'createBrandModal',
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.selectedBrand = data.data;
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async openLocationModal() {
    const modal = await this.modalCtrl.create({
      component: ChooseLocationModalComponent,
      componentProps: {
        previousSelectedLat: this.form.value.latitude,
        previousSelectedLng: this.form.value.longitude,
      },
      cssClass: 'location-selections-create',
      canDismiss: true,
      id: 'locationModal',
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        console.log(data);

        this.selectedLocation = data.data;
        this.form.patchValue({
          location: data.data.location,
          latitude: data.data.latitude,
          longitude: data.data.longitude,
        });
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  incrementPrice() {
    this.price++;
  }

  decrementPrice() {
    if (this.price > 1) {
      this.price--;
    } else {
      this.errorService.showToast(
        this.translate.instant(marker('Price.Error')),
      );
    }
  }

  removeImage(index: number) {
    this.productImages.splice(index, 1);
  }

  onAddItem(): void {
    this.form.markAllAsTouched();
    if (this.productImages.length < 1) {
      this.errorService.showAlert({
        title: this.translate.instant(marker('Product.Image.Limit')),
        text: this.translate.instant(marker('Product.Image.LimitDescription')),
      });
      return;
    }
    if (!this.form.valid) {
      return;
    }
    this.showLoader();
    this.form.patchValue({
      images: this.productImages,
      brand: this.selectedBrand.id,
      size_id: this?.selectedSize ? this.selectedSize?.id : null,
      category_id: this.selectedCategory.id,
      color_id: this.selectedColor.id,
      type_id: this.selectedType.id,
      brand_id: this.selectedBrand.id,
    });
    this.wardrobeService
      .createProduct(this.form.value)
      .pipe(finalize(() => this.hideLoader()))
      .subscribe(
        (res) => {
          this.form.reset();
          this.errorService.showToast(
            this.translate.instant(marker('Product.Create.Success')),
          );
          this.router.navigate(['tabs']);
        },
        (error) => {
          this.errorService.handle(error);
        },
      );
  }
}
